import type { ReactNode } from 'react';
import s from './InputErrorMessage.module.scss';
import InputAlert from '../../../../assets/icons/input-alert.svg';

interface InputErrorMessageProps {
  children?: ReactNode;
  id?: string;
}

function InputErrorMessage({ children, id }: InputErrorMessageProps) {
  return (
    <div id={id} className={s.errorMessageContainer}>
      <img className={s.errorMessageIcon} src={InputAlert} alt="" />
      <div className={s.errorMessageContent}>{children}</div>
    </div>
  );
}

export default InputErrorMessage;
